import { render, staticRenderFns } from "./ReadonlyAmendmentDialog.vue?vue&type=template&id=d2076e9c&scoped=true&"
import script from "./ReadonlyAmendmentDialog.vue?vue&type=script&lang=ts&"
export * from "./ReadonlyAmendmentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReadonlyAmendmentDialog.vue?vue&type=style&index=0&id=d2076e9c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2076e9c",
  null
  
)

export default component.exports